<template>
  <div>
    <h1 class="page-title">{{ $t('login.title') }}</h1>

    <form-container size="small">

      <b-form-group :label="$t('login.email')" label-for="email">
        <b-form-input
          id="email"
          name="email"
          type="email"
          v-model="email"
          :disabled="isLoading"
          v-validate="'required|email'"
          :data-vv-as="$t('login.email')"/>
        <span v-show="errors.has('email')" class="form__error">{{ errors.first('email') }}</span>
      </b-form-group>

      <b-form-group :label="$t('login.password')" label-for="password">
        <b-form-input
          id="password"
          name="password"
          type="password"
          v-model="password"
          :disabled="isLoading"
          v-validate="'required'"
          :data-vv-as="$t('login.password')"/>
        <span v-show="errors.has('password')" class="form__error">{{ errors.first('password') }}</span>
        <b-link
          class="reset-password-link"
          to="/reset-password">
          {{ $t('login.resetPassword') }}
        </b-link>
      </b-form-group>

      <b-button
        v-if="!isLoading"
        v-bind:disabled="!isValid || isLoading"
        @click="login"
        variant="primary">
          {{ $t('login.performLogin') }}
      </b-button>

      <loading-indicator v-if="isLoading"/>

      <b-alert v-if="errorMsg" variant="danger" show>{{ errorMsg }}</b-alert>
    </form-container>
  </div>
</template>

<script>
/**
* Shows a login form & performs the user login.
* Emits the event 'logged-in' when done.
*/
export default {
  name: 'LoginForm',
  data () {
    return {
      email: '',
      password: '',
      isLoading: false,
      error: null
    }
  },
  computed: {
    isValid () {
      return !this.errors.any()
    },
    errorMsg () {
      if (!this.error) {
        return
      }

      switch (this.error.code) {
        case 101: return this.$t('login.invalidCredentialsError')
      }

      return this.error.message
    }
  },
  methods: {
    async login () {
      if (!this.isValid) {
        return
      }

      this.error = null
      this.isLoading = true

      const params = { email: this.email.toLowerCase(), password: this.password }
      try {
        await this.$store.dispatch('login', params)
        this.$emit('logged-in')
      } catch (error) {
        this.error = error
      }

      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/shared-constants.scss";

.reset-password-link {
  margin-top: 10pt;
  display: block;
  font-size: $form-field-description-font-size;
  color: $hb-red;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue